import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 100 100"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "50",
      cy: "50",
      fill: "none",
      stroke: "#85a2b6",
      "stroke-width": "10",
      r: "35",
      "stroke-dasharray": "164.93361431346415 56.97787143782138"
    }, [
      _createElementVNode("animateTransform", {
        attributeName: "transform",
        type: "rotate",
        repeatCount: "indefinite",
        dur: "1s",
        values: "0 50 50;360 50 50",
        keyTimes: "0;1"
      })
    ], -1)
  ])))
}
export default { render: render }